import React, {useEffect, useId, useRef, useState} from "react";
import {FaPen} from "react-icons/fa6";
import InputForm from "../../../components/input-form";
import Button from "../../../components/button";

const EditableTitle = ({value, onSave, onEmptyBlur, className = "", inputClassName = "", label, allowEmpty = false, initiallyEditing = false, requireValue = false, readOnly = false}) => {
    const [isEditing, setIsEditing] = useState(initiallyEditing);
    const [draft, setDraft] = useState(value);
    const inputRef = useRef(null);
    const inputId = useId().replace(/:/g, "");

    useEffect(() => setDraft(value), [value]);

    useEffect(() => {
        if (readOnly) setIsEditing(false);
    }, [readOnly]);

    useEffect(() => {
        if (isEditing) {
            inputRef.current?.focus();
            inputRef.current?.select();
        }
    }, [isEditing]);

    const save = () => {
        const normalizedTitle = String(draft ?? "").trim();

        if (requireValue && !normalizedTitle) {
            setDraft("");
            return;
        }

        if ((allowEmpty || normalizedTitle) && normalizedTitle !== value) onSave(normalizedTitle);
        else setDraft(value);
        setIsEditing(false);
    };

    const handleKeyDown = event => {
        if (event.key === "Enter") {
            event.preventDefault();
            save();
        }
        if (event.key === "Escape") {
            if (requireValue && !String(value ?? "").trim()) {
                setDraft("");
                return;
            }

            setDraft(value);
            setIsEditing(false);
        }
    };

    const handleBlur = () => {
        if (requireValue && !String(draft ?? "").trim()) {
            onEmptyBlur?.();
            return;
        }

        save();
    };

    if (isEditing && !readOnly) {
        return (
            <InputForm
                reference={inputRef}
                id={`editable-title-${inputId}`}
                label="Título"
                value={draft}
                onChange={({target}) => setDraft(target.value)}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                autoFocus
                col={`min-w-0 w-full ${inputClassName}`}
            />
        );
    }

    if (readOnly) return <span className={`truncate ${className}`}>{value}</span>;

    return (
        <Button
            type="button"
            onClick={() => setIsEditing(true)}
            title="Editar"
            col={`group/title !h-auto min-w-0 !justify-start !border-0 !bg-transparent !p-0 text-left !shadow-none ${className}`}
        >
            <span className="truncate">{value}</span>
            <FaPen className="shrink-0 text-[10px] ml-2" />
        </Button>
    );
};

export default EditableTitle;
